import React from 'react';
import ProgressBar from './ProgressBar';
import NavigationButtons from './NavigationButtons';
import LanguagePicker from './LanguagePicker';
import InfoIcon from '../../assets/icons/info.js';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
function PageLayout({ 
    currentStep, 
    children, 
    navigationProps,
    infoText 
}) {
    const { t } = useTranslation();
    const containerStyles = {
        height: '98.7vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'var(--background-color)',
    };

    const progressBarStyles = {
        flexShrink: 0,
        zIndex: 50,
        paddingTop: '10px',
        paddingBottom: '10px',
        backgroundColor: 'var(--background-color)',
    };

    const topBarStyles = {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px 16px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        zIndex: 60
    };

    const contentStyles = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        minWidth: 0,
        backgroundColor: 'var(--background-color)',
    };

    const infoTextStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        color: '#666',
        fontSize: '14px',
        textAlign: 'center',
        maxWidth: '1000px',
        padding: '20px',
        margin: '0 auto',
        lineHeight: '1.4',
        backgroundColor: 'var(--background-color)',
    };

    const navigationStyles = {
        position: 'sticky',
        bottom: 0,
        flexShrink: 0,
        borderTop: '1px solid #e0e0e0',
        zIndex: 100,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        backgroundColor: 'var(--background-color)',
    };

    return (
        <div style={containerStyles}>
            <div style={topBarStyles}>
                <LanguagePicker />
            </div>
            {typeof currentStep === 'number' ? (
                <div style={progressBarStyles}>
                    <ProgressBar currentStep={currentStep} />
                </div>
            ) : null}
            
            <div style={contentStyles}>
                {children}
            </div>
            
            {infoText && (
                <div style={infoTextStyles}>
                    <InfoIcon />
                    <span>{t(infoText)}</span>
                </div>
            )}
            
            <div style={navigationStyles}>
                <NavigationButtons {...navigationProps} />
            </div>
        </div>
    );
}

PageLayout.propTypes = {
    currentStep: PropTypes.number,
    children: PropTypes.node.isRequired,
    navigationProps: PropTypes.object.isRequired,
    infoText: PropTypes.string
};

export default PageLayout; 